import React, { useEffect, useState } from 'react';

import styles from './OnLeashPrizeCountGraph.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../../Auth';
import { useAxios } from '../../../../../../../AxiosHandler';
import LineGraphCard from '../../../../Cards/LineGraphCard/LineGraphCard';

function OnLeashPrizeCountGraph(props: OnLeashPrizeCountGraphProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>();
    
    function getData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/use/leash/" + auth.selectedBreed + "/prizecounts",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            if (res.data?.length != 0) {
                setData({
                    labels: res.data.map((i: any) => i["SEASON"]),
                    datasets: [
                        {
                            label: t("statistics.areas.use.leash.prizecount.dataset_title_1"),
                            backgroundColor: "transparent",
                            // Green
                            pointBackgroundColor: "#68DB5A",
                            borderColor: "#68DB5A",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["ANT_FORSTE_PREMIER"]),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.use.leash.prizecount.dataset_title_2"),
                            backgroundColor: "transparent",
                            // Yellow
                            pointBackgroundColor: "#FFD700",
                            borderColor: "#FFD700",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["ANT_ANDRE_PREMIER"]),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.use.leash.prizecount.dataset_title_3"),
                            backgroundColor: "transparent",
                            // Orange
                            pointBackgroundColor: "#FFA500",
                            borderColor: "#FFA500",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["ANT_TREDJE_PREMIER"]),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.use.leash.prizecount.dataset_title_none"),
                            backgroundColor: "transparent",
                            // Gray
                            pointBackgroundColor: "#A9A9A9",
                            borderColor: "#A9A9A9",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["ANT_UPREMIERTE"]),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.use.leash.prizecount.dataset_title_null"),
                            backgroundColor: "transparent",
                            // Light gray
                            pointBackgroundColor: "#D3D3D3",
                            borderColor: "#D3D3D3",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["ANT_NULL_PREMIER"]),
                            tension: 0.5
                        }
                    ]
                });
            } else {
                setData(undefined);
            }
            props.onDataLoaded?.(res.data);
        }).catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getData();
        }
    }, [auth.selectedBreed, auth.selectedCountry]);

    return (
        <div className={styles.statisticshealth}>
            <LineGraphCard
                title={t("statistics.areas.use.leash.prizecount.title")}
                data={data}
                options={
                    {
                        scales: {
                            y: {
                                suggestedMin: 0,
                                suggestedMax: 10
                            }
                        }
                    }
                }
                description={t("statistics.areas.use.leash.prizecount.description")}
            ></LineGraphCard>
        </div>
    );
}

class OnLeashPrizeCountGraphProps {
    onDataLoaded?: (data: any) => void;
}

export default OnLeashPrizeCountGraph;